import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/views/client/PolicyPage/PolicyPage.tsx");
